import { useMemo } from "react";

import { useDebouncedValue } from "../../../../shared/hooks/useDebouncedValue";
import { PROJECT_MESSAGES } from "../../messages";
import { buildPreviewDocument } from "../../utils/project";
import type { FileMap } from "../../utils/project";

interface WebPreviewProps {
    files: FileMap;
}

// The learner's page, live. It runs inside a sandboxed frame: without "allow-same-origin" the page
// gets an empty origin, so the learner's JavaScript can't read this site's cookies or storage.
const WebPreview = ({ files }: WebPreviewProps) => {
    const document = useMemo(() => buildPreviewDocument(files), [files]);
    const shown = useDebouncedValue(document, 400); // Not rebuilt on every keystroke

    return (
        <iframe
            title={PROJECT_MESSAGES.previewTitle}
            sandbox="allow-scripts"
            srcDoc={shown}
            className="w-full h-[480px] rounded-lg bg-white"
        />
    );
};

export default WebPreview;